import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import _values from 'lodash/values'
import { formatOrderStatusTitle } from "@utils/format-order";
import { formatOrderPrepaidStatusTitle } from "@utils/format-order-prepaid"

export default [
  // ===
  // 預約加入購物車
  // ===
  {
    path: '/cart/add/reservation/:reservationAlias',
    name: 'add-reservation',
    component: () => lazyLoadView(import('@views/Cart/Add.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (!store.getters['merchant/isSiteEnabled'])
          next({ name: '404' })
          const [
            currentCart,
          ] = await Promise.all([
            store.dispatch('cart/fetchCart', {
              mockType: routeFrom.query.prepaidId
                ? 'deduct'
                : 'reservation'
            }),
          ]);

          const isCartNull = !currentCart.items.booking[0];
          const re = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]/;
          const date = !isCartNull && re.test(currentCart.items.booking[0].inventoryAlias) ? currentCart.items.booking[0].inventoryAlias : undefined

          if(isCartNull) {
            alert(`您的目前預約項目是空的 \n 系統將重新導向至首頁`);

            return next({ name: 'home' });
          } else {
            routeTo.params.cart = currentCart.items.booking[0];
          }

          const [
            currentMemberPetList,
            currentMember,
            currentApplicablePrepaidOrderList
          ] = await Promise.all([
            store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            }),
            store.dispatch('auth/fetchMember'),
            store.dispatch('order/fetchApplicablePrepaidOrderList', {
              paramAlias: routeTo.params.cart.param.alias,
              useCached: false,
              storeCached: false,
              date
            }),
          ]);

          routeTo.params.applicablePrepaidOrderList = currentApplicablePrepaidOrderList.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'reservation',
      applicablePrepaidOrderList: route.params.applicablePrepaidOrderList || []
    }),
  },
]